import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import AdminLoginPage from "./AdminLoginPage";
import AdminDashboardPage from "./AdminDashboardPage";

// Loading spinner for auth state resolution
const AuthLoader = () => (
  <div className="min-h-screen bg-gray-950 flex items-center justify-center">
    <svg className="animate-spin w-8 h-8 text-amber-500" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  </div>
);

// Guard: redirect to login if not authenticated
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <AuthLoader />;
  return user ? children : <Navigate to="/admin/login" replace />;
};

// Guard: redirect to dashboard if already authenticated
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <AuthLoader />;
  return !user ? children : <Navigate to="/admin/dashboard" replace />;
};

const AdminRouter = () => (
  <Routes>
    <Route
      path="login"
      element={
        <PublicRoute>
          <AdminLoginPage />
        </PublicRoute>
      }
    />
    <Route
      path="dashboard"
      element={
        <ProtectedRoute>
          <AdminDashboardPage />
        </ProtectedRoute>
      }
    />
    {/* Default redirect */}
    <Route path="*" element={<Navigate to="/admin/login" replace />} />
  </Routes>
);

export default AdminRouter;

